import React from 'react'
import { useRouteMatch, useHistory } from 'react-router-dom'

// core components
import GridContainer from '../../components/Grid/GridContainer.js'
import GridItem from '../../components/Grid/GridItem.js'
import Card from '../../components/Card/Card.js'
import CardBody from '../../components/Card/CardBody.js'
import CardIcon from '../../components/Card/CardIcon.js'
import CardHeader from '../../components/Card/CardHeader.js'

// Icons
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasketOutlined'

// components
import SiteSelector from '../Common/SiteSelector.js'

// report components
import { dashboardResponse, getSpecificCategories } from '../../layouts/Aws.js'

import SiteProducts from 'views/SiteProducts/SiteProducts.js'
import Products from 'views/Products/Products.js'

export default function ProductsWrapper () {
  const [siteList, setSiteList] = React.useState()
  const [selectedSiteId, setSelectedSiteId] = React.useState(null)
  const [selectedHyperionSiteId, setSelectedHyperionSiteId] = React.useState(null)
  const [initialSite, setInitialSite] = React.useState('')
  const [initialCategoryFilter, setInitialCategoryFilter] = React.useState(null)

  const history = useHistory()

  // we have to match these paths in this order, else we never get the match for both the site and category id
  const routeMatch = useRouteMatch({
    path: [
      '/app/products/:site_id/category/:category_id',
      '/app/products/:site_id'
    ]
  })

  // we only want to grab the initial site on the first load of the page - this allows us to still select other sites after the fact etc
  React.useEffect(() => {
    const processRoute = async () => {
      if (routeMatch !== null) {
        if (routeMatch.params.site_id) {
          setInitialSite(routeMatch.params.site_id)

          if (routeMatch.params.category_id) {
            const response = await getSpecificCategories(routeMatch.params.site_id, routeMatch.params.category_id)

            const filterCategories = []

            for (const category of response.payload) {
              filterCategories.push(category.id)
            }

            setInitialCategoryFilter(filterCategories)

            console.log('setting initial category filter:', filterCategories)
          }
        }

        // this command changes the url without reloading the page - this lets us keep the query string tidy
        history.push('/app/products')
      }
    }

    processRoute()
  }, [])

  React.useEffect(() => {
    dashboardResponse().then(res => {
      setSiteList(res.sites)
    })
  }, [])

  const onSiteSelected = async (newSite) => {
    for (const site of siteList) {
      if (site.id === newSite) {
        if (site.code === 'H') {
          setSelectedSiteId(null)
          setSelectedHyperionSiteId(newSite)
        } else {
          setSelectedSiteId(newSite)
          setSelectedHyperionSiteId(null)
        }
      }
    }
  }

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="danger" icon>
              <GridContainer>
                <GridItem xs={3} sm={3}>
                  <CardIcon color="danger">
                    <ShoppingBasketIcon />
                  </CardIcon>
                </GridItem>
                <GridItem xs={8} sm={6}>
                  <SiteSelector
                    siteList={siteList}
                    onSelect={onSiteSelected}
                    isGridItem={false}
                    autoSelect={false}
                    initialSite={initialSite}
                    // disabled={Object.keys(productUpdates).length > 0}
                    disabledTooltipText="Save changes to re-enable site selection" />
                </GridItem>
                <GridItem xs={1} sm={3}></GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              {
                selectedHyperionSiteId &&
                <SiteProducts siteId={selectedHyperionSiteId} categoryFilter={initialCategoryFilter} />
              }
              {
                selectedSiteId &&
                <Products siteId={selectedSiteId} />
              }
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  )
}
